import { render, staticRenderFns } from "./scope130.vue?vue&type=template&id=360d250e&scoped=true"
import script from "./scope130.vue?vue&type=script&lang=js"
export * from "./scope130.vue?vue&type=script&lang=js"
import style0 from "./scope130.vue?vue&type=style&index=0&id=360d250e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d250e",
  null
  
)

export default component.exports